import { FC } from 'react';
import { DescriptionList } from './DescriptionList';
import { DescriptionListItem } from './DescriptionListItem';

interface AgendaItemProps {
  subtitle: string;
  subtitleClarification?: string;
  descriptions: string[];
  src?: string;
}

export const AgendaItem: FC<AgendaItemProps> = ({ 
  subtitle,
  subtitleClarification,
  descriptions,
  src,
  }) => {
    return (
      <div className="flex flex-col justify-between md:flex-row items-start md:items-center mx-6 mb-6 md:gap-14">
        <div className="w-full mb-2 md:mb-0">        
          <h3 className="text-2xl xl:text-3xl font-bold mb-2 uppercase">{subtitle}</h3>
          <p className="text-lg font-semibold italic mb-2">{subtitleClarification}</p>
          <DescriptionList>
            {descriptions.map((description, i) => (
              <DescriptionListItem key={i} index={i} description={description} />
            ))}
          </DescriptionList>
        </div>
        <div className="w-full xs:w-2/3 md:w-3/4 lg:w-3/5">
          {src && <img src={src} alt={subtitle} className="w-full max-h-72" />}
        </div>
      </div>
    )
}